import { render } from "./ConfirmModal.vue?vue&type=template&id=2032c50a&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"

import "./ConfirmModal.vue?vue&type=style&index=0&id=2032c50a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2032c50a"]])

export default __exports__